<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-content">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="form-inline">
              <input
                type="text"
                v-model="filterText"
                class="form-control"
                placeholder="Pesquisar..."
              />
            </div>

            <div>
              <button class="btn btn-sm btn-primary" @click="refreshServices" title="Recarregar">
                <i class="mdi mdi-refresh fa-lg"></i>
              </button>
              <button class="btn btn-sm btn-secondary ml-2" @click="expandAll">
                <i class="mdi mdi-arrow-expand fa-lg"></i>
              </button>
              <button class="btn btn-sm btn-secondary ml-2" @click="collapseAll">
                <i class="mdi mdi-arrow-collapse fa-lg"></i>
              </button>
            </div>
          </div>

          <table
            class="footable table table-stripped toggle-arrow-tiny"
            data-page-size="15"
          >
            <thead>
              <tr>
                <th style="width: 40px"></th>
                <th @click="sortBy('codigo_companhia')" style="cursor: pointer">
                  Company ID
                  <i class="fa" :class="sortIcon('codigo_companhia')"></i>
                </th>
                <th
                  @click="sortBy('chave_servico')"
                  style="cursor: pointer"
                  data-toggle="true"
                >
                  Chave Serviço
                  <i class="fa" :class="sortIcon('chave_servico')"></i>
                </th>
                <th
                  @click="sortBy('updatedAt')"
                  style="cursor: pointer"
                  data-hide="phone"
                >
                  Última Atualização
                  <i class="fa" :class="sortIcon('updatedAt')"></i>
                </th>
                <th
                  @click="sortBy('hasCronError')"
                  style="cursor: pointer"
                  data-hide="phone"
                >
                  Status <i class="fa" :class="sortIcon('hasCronError')"></i>
                </th>
              </tr>
            </thead>

            <tbody>
              <template v-for="service in sortedSyncServices">
                <tr :key="service.id">
                  <td @click="toggleRow(service.id)" style="cursor: pointer">
                    <i
                      class="fa"
                      :class="
                        isRowExpanded(service.id)
                          ? 'fa-chevron-down'
                          : 'fa-chevron-right'
                      "
                    ></i>
                  </td>
                  <td :class="getStatusTextClass(service)">
                    {{ service.codigo_companhia }}
                  </td>
                  <td :class="getStatusTextClass(service)">
                    {{ service.chave_servico }}
                  </td>
                  <td :class="getStatusTextClass(service)">
                    {{ toBRDate(service.updatedAt) }}
                  </td>
                  <td>
                    <i
                      v-if="!service.hasCronError && !service.warning"
                      class="fa fa-check-circle text-success fa-lg"
                      title="OK"
                    ></i>
                    <i
                      v-if="service.hasCronError"
                      class="fa fa-exclamation-triangle text-danger fa-lg mr-1"
                      title="Erro"
                    ></i>
                    <i
                      v-if="service.warning"
                      class="fa fa-exclamation-triangle text-warning fa-lg"
                      :title="getWarningTitle(service)"
                    ></i>
                  </td>
                </tr>
                <tr
                  :key="`details-${service.id}`"
                  v-if="isRowExpanded(service.id)"
                >
                  <td :colspan="5" class="p-2">
                    <div class="p-3 border rounded">
                      <div>
                        <h5>Detalhes dos Crons</h5>
                        <table class="table table-sm table-hover table-striped">
                          <thead>
                            <tr>
                              <th>Cron</th>
                              <th>Data</th>
                              <th>Mensagem</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              v-for="cron in getCronArray(service.cron)"
                              :key="cron.cronName"
                            >
                              <td>{{ cron.cronName }}</td>
                              <td>{{ toBRDate(cron.data) }}</td>
                              <td>
                                <span
                                  :class="{
                                    'text-danger font-weight-bold':
                                      cron.error && cron.error === 'SIM',
                                  }"
                                  >{{ cron.mensagem }}</span
                                >
                              </td>
                            </tr>
                            <tr
                              v-if="
                                !service.cron ||
                                getCronArray(service.cron).length === 0
                              "
                            >
                              <td colspan="3" class="text-center">
                                Nenhum detalhe de cron disponível.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-if="service.server" >
                        <hr class="hr" />

                        <h4>Server</h4>

                        <div class="m-t-xs btn-group">
                          <div class="btn btn-sm btn-white">
                            IP: {{ service.server.ip }}
                          </div>
                          <div class="btn btn-sm btn-white" v-if="service.mdbs && service.mdbs.ip">
                            MDBS IP: {{ service.mdbs.ip }}
                          </div>
                          <div class="btn btn-sm btn-white">
                            Porta: {{ service.server.port }}
                          </div>
                          <div class="btn btn-sm btn-white">
                            Versão do Sync: {{ service.server.sync_version }}
                          </div>
                          <div class="btn btn-sm btn-white">
                            Versão do Mongo: {{ service.server.mongo_version }}
                          </div>
                          <div class="btn btn-sm btn-white">
                            Uptime: {{ service.server.uptime }}
                          </div>
                          <div class="btn btn-sm btn-white">
                            User: {{ service.codigo_usuario }}
                          </div>
                        </div>

                        <div
                          v-if="
                            service.server.node_version ||
                            service.server.os ||
                            getServerResources(service.server) ||
                            service.server.path_install
                          "
                          class="mt-3"
                        >
                          <h5>Ambiente do servidor</h5>
                          <div class="row">
                            <div class="col-md-4 mb-3" v-if="service.server.node_version || service.server.os">
                              <div class="border rounded p-3 h-100">
                                <strong class="d-block mb-2">Runtime e sistema</strong>
                                <div v-if="service.server.node_version">
                                  <span class="text-muted">Node.js:</span>
                                  {{ service.server.node_version }}
                                </div>
                                <div v-if="service.server.os">
                                  <span class="text-muted">Sistema operacional:</span>
                                  {{ formatOperatingSystem(service.server.os) }}
                                </div>
                              </div>
                            </div>

                            <div
                              v-for="resource in getServerResourceSections(service.server)"
                              :key="resource.key"
                              class="col-md-4 mb-3"
                            >
                              <div
                                class="border rounded p-3 h-100"
                                :class="isResourceWarning(service, resource) ? 'border-warning' : ''"
                              >
                                <strong class="d-block mb-2">
                                  {{ resource.label }}
                                  <span
                                    v-if="isResourceWarning(service, resource)"
                                    class="text-warning ml-1"
                                    :title="`Menos de ${syncResourceWarningThresholdPercent}% livre`"
                                  >
                                    <i class="fa fa-exclamation-triangle"></i>
                                    Atenção
                                  </span>
                                </strong>
                                <template v-if="resource.key === 'cpu'">
                                  <div>
                                    <span class="text-muted">Modelo:</span>
                                    {{ resource.values.model || '—' }}
                                  </div>
                                  <div>
                                    <span class="text-muted">Núcleos:</span>
                                    {{ formatResourceValue(resource.values.cores) }}
                                  </div>
                                  <div>
                                    <span class="text-muted">Uso:</span>
                                    {{ formatResourceValue(resource.values.used, resource.unit) }}
                                  </div>
                                </template>
                                <template v-else>
                                  <div>
                                    <span class="text-muted">Em uso:</span>
                                    {{ formatResourceValue(resource.values.used, resource.unit) }}
                                  </div>
                                  <div>
                                    <span class="text-muted">Livre:</span>
                                    {{ formatResourceValue(resource.values.free, resource.unit) }}
                                  </div>
                                  <div>
                                    <span class="text-muted">Total:</span>
                                    {{ formatResourceValue(resource.values.total, resource.unit) }}
                                  </div>
                                </template>
                              </div>
                            </div>

                            <div class="col-12 mb-3" v-if="service.server.path_install">
                              <div class="border rounded p-3">
                                <strong class="d-block mb-1">Diretório de instalação</strong>
                                <code class="text-break">{{ service.server.path_install }}</code>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="service.ultimo_erro">
                        <hr class="hr" />

                        <h4>Último erro</h4>

                        <div class="m-t-xs btn-group">
                          <div class="btn btn-sm btn-white">
                            Data: {{ toBRDate(service.ultimo_erro.data) }}
                          </div>
                          <div class="btn btn-sm btn-white">
                            Erro: {{ service.ultimo_erro.mensagem }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="6">
                  <ul class="pagination float-right"></ul>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment-timezone";

export default {
  name: "SyncServices",

  data() {
    return {
      expandedRows: [],
      sortKey: "hasCronError",
      sortOrder: "desc",
      filterText: "",
    };
  },

  computed: {
    ...mapState({
      syncServicesState: (state) => state.sync.syncServices,
      syncResourceWarningThresholdPercent: (state) =>
        state.sync.syncResourceWarningThresholdPercent
    }),

    filteredServices() {
      let services = [...this.syncServicesState];
      const filter = this.filterText.toLowerCase();

      if (!filter) {
        return services;
      }

      return services.filter((s) => {
        const companyId = s.codigo_companhia.toString().toLowerCase();
        const serviceKey = s.chave_servico.toLowerCase();
        const lastUpdate = this.toBRDate(s.updatedAt).toLowerCase();
        const status = s.hasCronError ? "erro" : "ok";

        return (
          companyId.includes(filter) ||
          serviceKey.includes(filter) ||
          lastUpdate.includes(filter) ||
          status.includes(filter)
        );
      });
    },

    sortedSyncServices() {
      const services = [...this.filteredServices];
      if (this.sortKey) {
        services.sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          if (this.sortKey === "hasCronError") {
            valA = this.getStatusPriority(a);
            valB = this.getStatusPriority(b);
          }

          let comparison = 0;
          if (valA > valB) {
            comparison = 1;
          } else if (valA < valB) {
            comparison = -1;
          }
          return this.sortOrder === "asc" ? comparison : -comparison;
        });
      }
      return services;
    },
  },

  methods: {
    ...mapActions("sync", ["fetchSyncServices"]),

    async refreshServices() {
      await this.fetchSyncServices();
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },

    sortIcon(key) {
      if (this.sortKey !== key) {
        return "fa-sort";
      }
      return this.sortOrder === "asc" ? "fa-sort-up" : "fa-sort-down";
    },

    getStatusPriority (service) {
      if (service.hasCronError && service.warning) {
        return 3
      }
      if (service.hasCronError) {
        return 2
      }
      if (service.warning) {
        return 1
      }
      return 0
    },

    getStatusTextClass (service) {
      if (service.hasCronError) {
        return 'text-danger'
      }
      return service.warning ? 'text-warning' : ''
    },

    getWarningTitle (service) {
      const resources = service.warningResources || []
      return resources.length
        ? `Atenção: pouco recurso livre em ${resources.join(', ')}`
        : 'Atenção: recurso com pouco espaço livre'
    },

    isResourceWarning (service, resource) {
      return (service.warningResources || []).includes(resource.label)
    },

    expandAll() {
      this.expandedRows = this.sortedSyncServices.map((s) => s.id);
    },

    collapseAll() {
      this.expandedRows = [];
    },

    toggleRow(serviceId) {
      const index = this.expandedRows.indexOf(serviceId);
      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(serviceId);
      }
    },

    isRowExpanded(serviceId) {
      return this.expandedRows.includes(serviceId);
    },

    getCronArray(cronObject) {
      if (!cronObject || Object.keys(cronObject).length === 0) {
        return [];
      }

      return Object.entries(cronObject).map(([cronName, detailsArray]) => {
        const details = detailsArray[detailsArray.length - 1] || detailsArray || {};

        return {
          cronName,
          ...details,
        };
      });
    },

    getServerResources (server) {
      return server.resources || server.resouces || null
    },

    getServerResourceSections (server) {
      const resources = this.getServerResources(server)
      if (!resources) {
        return []
      }

      return [
        { key: 'memory', label: 'Memória', unit: 'GB', values: resources.memory },
        { key: 'cpu', label: 'CPU', unit: '%', values: resources.cpu },
        { key: 'disk', label: 'Disco', unit: 'GB', values: resources.disk }
      ].filter((resource) => resource.values)
    },

    formatOperatingSystem (os) {
      return [os.platform, os.release, os.arch].filter(Boolean).join(' · ') || '—'
    },

    formatResourceValue (value, unit = '') {
      if (value === null || value === undefined || value === '') {
        return '—'
      }

      const formattedValue =
        typeof value === 'number' ? value.toLocaleString('pt-BR') : value
      return unit ? `${formattedValue} ${unit}` : formattedValue
    },

    toBRDate(dateString) {
      if (!dateString) {
        return "";
      }

      return moment.utc(dateString).format("DD/MM/YYYY HH:mm:ss");
    },
  },

  async mounted() {
    await this.fetchSyncServices();
  },
};
</script>
